// Cursor
const cur = document.getElementById('cur');
const ring = document.getElementById('curRing');
if (cur && ring) {
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; });
  (function tick() {
    cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    rx += (mx - rx) * .13; ry += (my - ry) * .13;
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(tick);
  })();
}

// Nav scroll
const nav = document.getElementById('mainNav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  });
}

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
}, { threshold: 0.12 });
reveals.forEach(el => obs.observe(el));

// Add to cart via AJAX
function addToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bagBtn = document.querySelector('.nav-cart');
        if (bagBtn) bagBtn.textContent = 'Bag (' + cart.item_count + ')';
      });
  })
  .catch(err => console.error('Add to cart error:', err));
}
